module.exports = __webpack_public_path__ + "static/img/icon_man.0943e05c.svg";